export default "__VITE_ASSET__9639a4fc__"